import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ServiceBase } from '@app/services/base.service';
import { Entrevista } from '@app/models/entrevista.model';


@Injectable()
export class EntrevistaService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(entrevista: Entrevista): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'entrevista', entrevista);
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `entrevista/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `entrevista/${id}`);
  }

  obterPesquisa(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `entrevista/pesquisar/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

  obterEntrevista(id: number, processoId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `entrevista/${id}/${processoId}`);
  }

  gravarEntrevista(entrevista: Entrevista, processoId: number): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'entrevista/SalvarEntrevista?processoId=' + processoId, entrevista);
  }

  obterTodos(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `entrevista`);
  }
}
